// Generated by Melange

import * as Ppx_deriving_json_runtime from "melange-json.ppx-runtime/ppx_deriving_json_runtime.jsx";
import * as Subsonic__BaseAlbum from "./baseAlbum.jsx";
import * as Subsonic__Response from "./response.jsx";

function artist_of_json(x) {
  if (!(typeof x === "object" && !Array.isArray(x) && x !== null)) {
    Ppx_deriving_json_runtime.of_json_error("expected a JSON object");
  }
  const v = x.album;
  const v$1 = x.albumCount;
  const v$2 = x.coverArt;
  const v$3 = x.id;
  const v$4 = x.musicBrainzId;
  const v$5 = x.name;
  const v$6 = x.starred;
  const v$7 = x.userRating;
  return {
    album: v !== undefined ? Ppx_deriving_json_runtime.Primitives.option_of_json((function (param) {
        return Ppx_deriving_json_runtime.Primitives.array_of_json(Subsonic__BaseAlbum.of_json, param);
      }), v) : undefined,
    albumCount: v$1 !== undefined ? Ppx_deriving_json_runtime.Primitives.int_of_json(v$1) : Ppx_deriving_json_runtime.of_json_error("missing field \"albumCount\""),
    coverArt: v$2 !== undefined ? Ppx_deriving_json_runtime.Primitives.string_of_json(v$2) : Ppx_deriving_json_runtime.of_json_error("missing field \"coverArt\""),
    id: v$3 !== undefined ? Ppx_deriving_json_runtime.Primitives.string_of_json(v$3) : Ppx_deriving_json_runtime.of_json_error("missing field \"id\""),
    musicBrainzId: v$4 !== undefined ? Ppx_deriving_json_runtime.Primitives.option_of_json(Ppx_deriving_json_runtime.Primitives.string_of_json, v$4) : undefined,
    name: v$5 !== undefined ? Ppx_deriving_json_runtime.Primitives.string_of_json(v$5) : Ppx_deriving_json_runtime.of_json_error("missing field \"name\""),
    starred: v$6 !== undefined ? Ppx_deriving_json_runtime.Primitives.option_of_json(Ppx_deriving_json_runtime.Primitives.string_of_json, v$6) : undefined,
    userRating: v$7 !== undefined ? Ppx_deriving_json_runtime.Primitives.option_of_json(Ppx_deriving_json_runtime.Primitives.int_of_json, v$7) : undefined
  };
}

function artist_to_json(x) {
  return {
    album: Ppx_deriving_json_runtime.Primitives.option_to_json((function (param) {
      return Ppx_deriving_json_runtime.Primitives.array_to_json(Subsonic__BaseAlbum.to_json, param);
    }), x.album),
    albumCount: x.albumCount,
    coverArt: x.coverArt,
    id: x.id,
    musicBrainzId: Ppx_deriving_json_runtime.Primitives.option_to_json((function (prim) {
      return prim;
    }), x.musicBrainzId),
    name: x.name,
    starred: Ppx_deriving_json_runtime.Primitives.option_to_json((function (prim) {
      return prim;
    }), x.starred),
    userRating: Ppx_deriving_json_runtime.Primitives.option_to_json((function (prim) {
      return prim;
    }), x.userRating)
  };
}

function body_of_json(x) {
  if (!(typeof x === "object" && !Array.isArray(x) && x !== null)) {
    Ppx_deriving_json_runtime.of_json_error("expected a JSON object");
  }
  const v = x.status;
  let tmp;
  if (v !== undefined) {
    const tag = Ppx_deriving_json_runtime.Primitives.string_of_json(v);
    tmp = tag === "ok" ? "ok" : Ppx_deriving_json_runtime.of_json_error("invalid JSON");
  } else {
    tmp = Ppx_deriving_json_runtime.of_json_error("missing field \"status\"");
  }
  const v$1 = x.artist;
  return {
    status: tmp,
    artist: v$1 !== undefined ? artist_of_json(v$1) : Ppx_deriving_json_runtime.of_json_error("missing field \"artist\"")
  };
}

function body_to_json(x) {
  return {
    status: "ok",
    artist: artist_to_json(x.artist)
  };
}

function of_json(x) {
  return Subsonic__Response.of_json(body_of_json, x);
}

function to_json(x) {
  return Subsonic__Response.to_json(body_to_json, x);
}

export {
  artist_of_json,
  artist_to_json,
  body_of_json,
  body_to_json,
  of_json,
  to_json,
}
/* No side effect */
